import { useState } from "react";
import { Button } from "@/components/ui/button";
import { toast } from "sonner";
import { api } from "@/lib/api";
import { useApi } from "@/hooks/useApi";
import { Section, DataTable, StatusBadge, Loading } from "@/components/common/ui-bits";
import { FormDialog } from "@/components/common/FormDialog";
import { fmtDateTime } from "@/lib/format";

export function ConsentPanel({ data, reload }) {
  const [edit, setEdit] = useState(null);
  if (!data) return <Loading />;
  const off = (c) => Object.entries(c.prefs).filter(([, v]) => !v).map(([k]) => k);
  return (
    <div className="space-y-6">
      <Section title="Consentimiento de marketing por cliente" testid="consent-clients">
        <p className="mb-3 text-sm text-slate-500">Las campañas solo llegan a clientes con consentimiento. El cliente puede cambiarlo en su portal o darse de baja con el enlace de cada correo.</p>
        <DataTable testid="consent-table" rows={data.clients} columns={[
          { key: "client_name", label: "Cliente" }, { key: "email", label: "Correo" },
          { key: "consent", label: "Marketing", render: (c) => <StatusBadge status={c.consent ? "Con consentimiento" : "Sin consentimiento"} testid={`consent-status-${c.id}`} /> },
          { key: "marketing", label: "Último cambio", render: (c) => c.marketing ? <span className="text-xs">{c.marketing.source} · {fmtDateTime(c.marketing.at)}</span> : "—" },
          { key: "prefs", label: "Avisos desactivados", render: (c) => off(c).join(", ") || "Ninguno" },
          { key: "act", label: "", render: (c) => <Button size="sm" variant="outline" onClick={() => setEdit(c)} data-testid={`consent-edit-${c.id}`}>{c.consent ? "Retirar" : "Registrar"}</Button> }]} />
      </Section>
      <Section title="Historial de consentimientos" testid="consent-log">
        {!data.log.length ? <p className="text-sm text-slate-400">Sin cambios registrados.</p> :
          <ul className="divide-y divide-slate-100 text-sm">{data.log.map((l) => <li key={l.id} className="flex flex-wrap justify-between gap-2 py-2"><span><b>{l.client_name}</b> — {l.consent ? "otorgó" : "retiró"} consentimiento · {l.source}{l.note ? ` · ${l.note}` : ""}</span><span className="text-xs text-slate-500">{l.by} · {fmtDateTime(l.at)}</span></li>)}</ul>}
      </Section>
      <FormDialog open={Boolean(edit)} onOpenChange={(o) => !o && setEdit(null)} testid="consent-form" submitLabel="Guardar"
        title={edit?.consent ? "Retirar consentimiento" : "Registrar consentimiento"}
        description={edit?.consent ? `${edit?.client_name} dejará de recibir correos de marketing.` : `Registre solo si ${edit?.client_name} aceptó recibir marketing y anote cómo (por escrito, llamada, formulario…).`}
        fields={[{ name: "note", label: "Detalle / evidencia", type: "textarea", required: true, minLength: 5 }]}
        onSubmit={async (v) => { await api.put(`/clients/${edit.id}/marketing-consent`, { consent: !edit.consent, note: v.note }); toast.success("Consentimiento actualizado"); reload(); }} />
    </div>
  );
}

export function useConsents() {
  return useApi("/marketing/consents");
}
